import type { Blueprint, ThemeDefinition } from 'vuetify';
import colors from '../styles/colors.module.scss';

const light: ThemeDefinition = {
    colors: {
        'on-surface': colors.greyDarken5,
        primary: colors.greenDarken1,
        secondary: colors.greyDarken4,
        'on-secondary': colors.onGreyDarken4,
        header: colors.greyDarken4,
        'on-header': colors.onGreyDarken4,
        footer: colors.greyDarken4,
        'on-footer': colors.onGreyDarken4
    }
};

const dark: ThemeDefinition = {
    colors: {
        'on-surface': colors.white,
        primary: colors.greenLighten1,
        secondary: colors.greyDarken4,
        'on-secondary': colors.onGreyDarken4,
        header: colors.greyDarken4,
        'on-header': colors.onGreyDarken4,
        footer: colors.greyDarken4,
        'on-footer': colors.onGreyDarken4
    }
};

export default {
    defaults: {
        VAppBar: {
            flat: true,

            VIcon: {
                size: 32
            }
        },
        ...Object.fromEntries(
            ['VAutocomplete', 'VCombobox', 'VFileInput', 'VSelect', 'VTextField', 'VTextarea'].map(component => [
                component,
                { variant: 'outlined' }
            ])
        )
    },
    display: {
        mobileBreakpoint: 'md',
        thresholds: {
            lg: 1140
        }
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light,
            dark
        }
    }
} as Blueprint;

export { light, dark, colors };
